import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Web-specific hook for handling post-authentication redirect.
 * Manages the "after" and "signup" URL parameters to:
 * - Redirect users back to their intended destination after login
 * - Control whether to show signup or login form by default
 */
export interface UseLoginRedirectResult {
  afterParam: string | null;
  signupParam: string | null;
  shouldStartInSignupMode: boolean;
  redirectAfterSuccess: () => void;
}

export function useLoginRedirect(): UseLoginRedirectResult {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const afterParam = searchParams.get('after');
  const signupParam = searchParams.get('signup');

  const redirectAfterSuccess = useCallback(() => {
    navigate(afterParam || '/home');
  }, [navigate, afterParam]);

  const shouldStartInSignupMode = signupParam !== 'false';

  return {
    afterParam,
    signupParam,
    shouldStartInSignupMode,
    redirectAfterSuccess,
  };
}
